"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CONTACT: true,
  UNKNOWN: false
};
exports.default = _default;
module.exports = exports.default;